import React from 'react';
import { useFontLoader } from '../../../../dummies/RichTextEditor/useFontLoader';

const Simple = ({ text, FIXED_TEXT_WIDTH, FIXED_TEXT_HEIGHT }) => {
  // טעינת פונטים מה-HTML
  useFontLoader(text);
  const boardStyle = {
    width: '100%',
    height: `${FIXED_TEXT_HEIGHT}px`,
    display: 'flex',
    flexDirection: 'column',
    direction: 'rtl',
    position: 'relative'
  };

  return (
    <div style={boardStyle}>
      {/* תוכן הטקסט הממורכז */}
      <div style={{
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div style={{
          fontSize: '32px',
          color: '#3E2723',
          fontWeight: 'bold',
          width: '100%'
        }}
          dangerouslySetInnerHTML={{ __html: text || "טקסט קבוע" }}
        />
      </div>
    </div>
  );
};

export default Simple;